import React from "react";

const Principles = () => {
	return (
		<section className="flex items-center justify-center lg:py-16 lg:px-24 p-10 bg-gray-100">
			<div className="flex justify-between w-full">
				<div className="lg:w-1/2">
					<blockquote className="lg:text-2xl font-semibold italic mb-8">
						"Seva Sadbhaavaad Santoshaah" – Joy lies in serving with goodwill.
					</blockquote>
					<div className="flex lg:flex-row flex-col gap-8 mb-8">
						<div className="bg-teal-50 p-4 shadow-lg w-full rounded-lg">
							<h3 className="text-teal-600 text-xl font-bold">Our Mission</h3>
							<p className="text-sm text-gray-600 leading-relaxed">
								We strive to serve humanity by addressing social, educational, environmental, and cultural needs.
							</p>
						</div>
						<div className="bg-teal-50 p-4 shadow-lg w-full rounded-lg">
							<h3 className="text-teal-600 text-xl font-bold">Our Vision</h3>
							<p className="text-sm text-gray-600 leading-relaxed">
								Over the years, we have touched countless lives through initiatives like elder care, educational support, skill development, environmental protection, and spiritual harmony.
							</p>
						</div>
					</div>
					<div className="mt-8">
						<div className="mb-4">
							<div className="flex justify-between font-semibold">
								<label className="text-gray-700">Donations</label>
								<span className="text-gray-700">75%</span>
							</div>
							<div className="bg-teal-100 h-4 w-full rounded-lg mt-1">
								<div className="bg-teal-600 h-full rounded-lg" style={{ width: "75%" }}></div>
							</div>
						</div>
						<div className="mb-4">
							<div className="flex justify-between font-semibold">
								<label className="text-gray-700">Social Service</label>
								<span className="text-gray-700">90%</span>
							</div>
							<div className="bg-teal-100 h-4 w-full rounded-lg mt-1">
								<div className="bg-teal-600 h-full rounded-lg" style={{ width: "90%" }}></div>
							</div>
						</div>
					</div>
				</div>
				<div className="w-2/5 lg:block hidden">
					<img
						src="/images/principles.png"
						alt="Principles"
						className="w-full h-auto rounded-lg"
					/>
				</div>
			</div>
		</section>
	);
};

export default Principles;
